import React from 'react';

const Input = ({
  label,
  name,
  type = 'text',
  placeholder,
  value,
  onChange,
  required = false,
}) => {
  return (
    <div className="form-group mb-4">
      {label && (
        <label htmlFor={name} className="form-label">
          {label} <span className="required-star">{required?'*':''}</span>
        </label>
      )}
      <input
        type={type}
        id={name}
        name={name}
        className="form-control"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        required={required}
      />
    </div>
  );
};

export default Input;
